import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { JobFinanceGetResponse } from '../services/JobFinanceService';

export const handlers = [
  http.put(mockTruktTmsApiUrl('/jobs/:jobGuid/finances'), () => {
    return HttpResponse.json(undefined);
  }),
  http.get(mockTruktTmsApiUrl('/jobs/:jobGuid/finances'), () => {
    return HttpResponse.json<JobFinanceGetResponse>();
  }),
];
